import { CustomerIcon } from "@/components/RFIcon";
import { useRouter } from "next/router";

export default function BrowserCustomer() {
	const router = useRouter();
	const handleOpenCustomService = () => {
		router.push("/contact-us");
	};

	return (
		<div
			className="inline-flex w-[2.125rem] h-[2.125rem] rounded-full dark:bg-black_1a bg-smallBg items-center justify-center"
			onClick={handleOpenCustomService}
		>
			<CustomerIcon className="w-[17px] h-[17px]" />
		</div>
	);
}
